import { withFormsy } from 'formsy-react'
import React from 'react'
import {
  Wrapper,
  FieldWrapper,
  FieldName,
  ErrorMessage
} from './FormInput.styles'
import { StyledTextarea } from './Textarea.styles'

class Textarea extends React.Component {
  constructor (props) {
    super(props)
    this.changeValue = this.changeValue.bind(this)
  }

  changeValue (event) {
    this.props.onChange ? this.props.onChange(event) : null
    this.props.setValue(event.currentTarget.value)
  }

  getErrorMessage () {
    if (this.props.validateOnType) {
      return this.props.getErrorMessage()
    }
    if (!this.props.isFormSubmitted()) return
    if (this.props.isRequired() && !this.props.getValue()) {
      return `${this.props.fieldName || 'This field'} is required`
    }
    return this.props.getErrorMessage()
  }

  render () {
    return (
      <Wrapper
        className={this.props.className}
        width={this.props.width}
      >
        <FieldWrapper
          displayStyle={this.props.displayStyle}
        >
          <FieldName
            color={this.props.fieldNameColor}
            textSize={this.props.fieldNameSize}
          >
            {this.props.fieldName}
          </FieldName>
          <StyledTextarea
            name={this.props.name}
            placeholder={this.props.placeholder || ''}
            placeholderColor={this.props.placeholderColor}
            color={this.props.inputColor}
            onChange={this.changeValue}
            value={this.props.getValue() || ''}
            inputWidth={this.props.inputWidth}
            textSize={this.props.textSize}
            rows={this.props.rows}
            resizable={this.props.resizable}
            backgroundColor={this.props.backgroundColor}
            focusColor={this.props.focusColor}
            backgroundFocusColor={this.props.backgroundFocusColor}
            errorColor={this.props.errorColor}
            noBorder={this.props.noBorder}
            isInvalid={this.getErrorMessage() && true}
            disabled={this.props.disabled}
            narrow={this.props.narrow}
            noRadius={this.props.noRadius}
            topBorderOnly={this.props.topBorderOnly}
          />
        </FieldWrapper>
        <ErrorMessage errorColor={this.props.errorColor} positionRelative={this.props.positionRelative}>
          {this.getErrorMessage()}
        </ErrorMessage>
      </Wrapper>
    )
  }
}

export default withFormsy(Textarea)
